export default "__VITE_ASSET__BGqLQpn$__"